
import {
    IS_LOADING_START,
    IS_LOADING_STOP,

    GET_LIST_ALL_REPORT_SUCCESS,
    GET_LIST_ALL_REPORT_FAILURE,

} from "./Types";


// notify
import { notify } from "../../components/common/Toaster";

// api services
import { _addReport } from "../../config/api/AddServices";
import { getTagForFIlters } from "./Tag"

import { _getReports, _getMyReports } from "../../config/api/GetServices"


// url
import Url from "../../config/env/BaseUrl";
import { _Api } from "../../config/api/Api";



// action for getUser list
export const getAllReportList = req => dispatch => {
    dispatch({ type: IS_LOADING_START })
    getTagForFIlters({ tagType: req.tagType, folder: req.folder })(dispatch)
    _Api(Url.ADMIN_GET_REPORTS.method, Url.ADMIN_GET_REPORTS.url, req)
        .then(resp => {
            let payload = {
                reportInfo: resp.responseData
            }
            dispatch({ type: GET_LIST_ALL_REPORT_SUCCESS, payload })
            dispatch({ type: IS_LOADING_STOP })

        }).catch(err => {

            dispatch({ type: IS_LOADING_STOP })

        })

}


// add users
export const addNewReport = (req, id, req2) => dispatch => {

    dispatch({ type: IS_LOADING_START })
    _Api(Url.ADMIN_ADD_REPORT.method, Url.ADMIN_ADD_REPORT.url, req)
        .then(resp => {
            getAllReportList(req2)(dispatch)
            dispatch({ type: IS_LOADING_STOP })
            setTimeout(() => { notify("success", resp.responseData.message) }, 300)
        }).catch(err => {
            dispatch({ type: IS_LOADING_STOP })
            if (err.error)
                notify("err", err.error.message)
            else if (err)
                notify("err", err.message)

        })

}
